import type { LucideIcon } from 'lucide-react';
import { renderToStaticMarkup } from 'react-dom/server';

const cache = new Map<LucideIcon, Map<number, string>>();

/** The icon as inline SVG for the DOM-built badges of `PlaceholderTextField` (current colour). */
export const iconMarkup = (Icon: LucideIcon, size = 14): string => {
    const sizes = cache.get(Icon) ?? new Map<number, string>();
    let markup = sizes.get(size);

    if (markup === undefined) {
        markup = renderToStaticMarkup(<Icon size={size} aria-hidden />);
        sizes.set(size, markup);
        cache.set(Icon, sizes);
    }

    return markup;
};
